module.exports = __webpack_public_path__ + "856e1fc50b2eab92332de1b56143a349.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ice-cream.png
// module id = 2399
// module chunks = 0